export default __webpack_public_path__ + "static/media/giftbox.43d1bae8.svg";